import { render } from "./CustomShiftPage.vue?vue&type=template&id=10003500&scoped=true&ts=true"
import script from "./CustomShiftPage.ts?vue&type=script&lang=ts"
export * from "./CustomShiftPage.ts?vue&type=script&lang=ts"

import "./CustomShiftPage.vue?vue&type=style&index=0&id=10003500&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10003500"]])

export default __exports__